import React, { useEffect, useState } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../utils/msalConfig';
import LoginPage from '../pages/LoginPage';

export default function AuthWrapper({ children }) {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [tokenReady, setTokenReady] = useState(false);

  useEffect(() => {
    if (inProgress === InteractionStatus.None && isAuthenticated && accounts.length > 0) {
      instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      }).then(response => {
        sessionStorage.setItem('auth_token', response.idToken);
        setTokenReady(true);
      }).catch(err => {
        console.error('Silent token acquisition failed:', err);
        sessionStorage.removeItem('auth_token');
        setTokenReady(false);
      });
    }
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      sessionStorage.removeItem('auth_token');
      setTokenReady(false);
    }
  }, [instance, inProgress, isAuthenticated, accounts]);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>
        Signing in...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (!tokenReady) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>
        Loading...
      </div>
    );
  }

  return children;
}